


































import BaseFilter from "@/components/Filter/BaseFilter";
import { PushHistoryFilterParams } from "@/store/push/statistic/types";
import { Component, PropSync, Watch } from "vue-property-decorator";
import { DatePickerWings, FastDateGroupWings } from "wings-ui-components";
import { currentDay, onlyDateFilter } from "@/utils/date-util";
import { Action } from "vuex-class";
import { notifyError } from "@/utils/notify-helper";

@Component({
  components: {FastDateGroupWings, DatePickerWings},
  filters: {onlyDateFilter}
})
export default class PushSubscriberCountFilter extends BaseFilter<PushHistoryFilterParams> {

  @PropSync("show") is_show_primary!: boolean;
  @PropSync("filterClone") propFilterClone!: PushHistoryFilterParams;
  @PropSync("runFilter") propRunFilter!: boolean;

  @Action("getPushSubscribersCount") actionGetStatisticCount: any;
  @Action("actionLog") actionLog: any;

  defaultFilter(): PushHistoryFilterParams {
    return {
      date_from: currentDay(),
      date_to: currentDay(),
    };
  }

  async onFilteredAction() {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Subscribers",
        addititional_info: this.filter
      };
      await this.actionGetStatisticCount(this.filter);
      await this.actionLog(this.logObject);
    } catch (err) {
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(err);
    }
  }

  @Watch('filter', { immediate: true, deep: true })
  onFilterChange(val: PushHistoryFilterParams) {
    this.propFilterClone = val;
  }

  @Watch('runFilter', { immediate: true })
  onRunFilterChange(val: boolean) {
    if (val) {
      this.filtered();
      this.propRunFilter = false;
    }
  }
}
